module.exports = __webpack_public_path__ + "img/logo-on-color.27c76aa.png";